import React from 'react';
import { Box, Button, Modal, Typography, IconButton } from '@mui/material';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const PDFDownloadModal = ({
  downloadPDFUrl,
  setDownloadPDFUrl,
}: {
  downloadPDFUrl: string;
  setDownloadPDFUrl: (url: string | null) => void;
}) => {
  return (
    <Modal open={Boolean(downloadPDFUrl)} onClose={() => setDownloadPDFUrl(null)}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'clamp(320px, 100%, 520px)',
          bgcolor: 'white',
          borderRadius: '10px',
          p: 3,
          boxShadow: '0 0 10px 0 rgba(0,0,0,0.1)',
          outline: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          zIndex: 1000,
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={() => setDownloadPDFUrl(null)}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'red',
            '&:hover': {
              backgroundColor: 'rgba(255, 0, 0, 0.1)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <Typography
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            mb: 1,
            fontSize: '1.5rem',
          }}
        >
          Market PDF is generated successfully!
        </Typography>

        {/* Body Text */}
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            mb: 2,
            color: 'text.secondary',
          }}
        >
          Your PDF is now ready for viewing. Click the button below to open it.
        </Typography>

        {/* Action Button */}
        <Button
          variant="contained"
          startIcon={<OpenInNewIcon />}
          onClick={() => {
            window.open(downloadPDFUrl, '_blank');
          }}
          sx={{
            backgroundColor: '#20B2AA', // Teal color
            color: 'white',
            px: 3,
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 'bold',
            borderRadius: '8px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#1A9B94',
            },
          }}
        >
          Open Market PDF
        </Button>
      </Box>
    </Modal>
  );
};

export default PDFDownloadModal;
